webpackJsonp(["site__ale001"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/event/shadow-focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _activeElements = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/active-elements.js");

var _activeElements2 = _interopRequireDefault(_activeElements);

var _decorateService = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Utility to observe focus changes within ShadowDOMs.

  USAGE:
    engage();
    document.body.addEventListener('shadow-focus', function(event) {
      // event.detail.elements: complete focus ancestry (array of nodes)
      // event.detail.active: the actually focused element within the ShadowDOM
      // event.detail.hosts: the shadow host ancestry of the active element
    }, false);

  Alternate implementation: https://github.com/cdata/focus-observer
*/

var engage = void 0;
var disengage = void 0;

if (typeof document === 'undefined' || !document.documentElement.createShadowRoot) {
  // no need to initialize any of this if we don't have ShadowDOM available
  engage = disengage = function disengage() {};
} else {
  var blurTimer = void 0;
  var blurElement = void 0;

  var handleElementBlurEvent = function handleElementBlurEvent() {
    stopHandleElementBlurEvent();
    // abort any handlers that come from document blur handler
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurTimer = (window.setImmediate || window.setTimeout)(function () {
      handleFocusChange();
    });
  };

  var observeElementBlurEvent = function observeElementBlurEvent(element) {
    // call us when we're leaving the element
    element.addEventListener('blur', handleElementBlurEvent, true);
    blurElement = element;
  };

  var stopHandleElementBlurEvent = function stopHandleElementBlurEvent() {
    // once() - sometimes I miss jQuery's simplicity…
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    blurElement = null;
  };

  var handleFocusChange = function handleFocusChange() {
    var _active = (0, _activeElements2.default)();
    if (_active.length === 1) {
      stopHandleElementBlurEvent();
      return;
    }

    // listen for blur so we know when to re-validate
    observeElementBlurEvent(_active[0]);
    var shadowFocusEvent = new CustomEvent('shadow-focus', {
      bubbles: false,
      cancelable: false,
      detail: {
        // complete focus ancestry
        elements: _active,
        // the actually focused element
        active: _active[0],
        // shadow host ancestry
        hosts: _active.slice(1)
      }
    });

    document.dispatchEvent(shadowFocusEvent);
  };

  var handleDocumentFocusEvent = function handleDocumentFocusEvent() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    handleFocusChange();
  };

  engage = function engage() {
    document.addEventListener('focus', handleDocumentFocusEvent, true);
  };

  disengage = function disengage() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    document.removeEventListener('focus', handleDocumentFocusEvent, true);
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/active-elements.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (document.activeElement === null) {
    // IE10 does not redirect focus to <body> when the activeElement is removed
    document.body.focus();
  }

  // Firefox currently leaks the shadowed element
  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1117535
  if ((0, _shadowed2.default)(document.activeElement)) {
    return walkFromShadowedElement();
  }

  return walkToShadowedElement();
};

var _shadowed = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/shadowed.js");

var _shadowed2 = _interopRequireDefault(_shadowed);

var _shadowHostParents = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host-parents.js");

var _shadowHostParents2 = _interopRequireDefault(_shadowHostParents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// [0] always is the actual active element (even within web-components)
// [0+n] is the hierarchy of shadow-doms with [length -1] being the top most shadow-host

function walkToShadowedElement() {
  var list = [document.activeElement];

  while (list[0] && list[0].shadowRoot) {
    list.unshift(list[0].shadowRoot.activeElement);
  }

  return list;
}

function walkFromShadowedElement() {
  var hosts = (0, _shadowHostParents2.default)({ context: document.activeElement });
  return [document.activeElement].concat(hosts);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host-parents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host-parents',
    context: context
  });

  while (element) {
    element = (0, _shadowHost2.default)({ context: element });
    if (!element) {
      break;
    }

    list.push(element);
  }

  return list;
};

var _shadowHost = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host',
    context: context
  });

  // walk up to the root
  var container = null;

  while (element) {
    container = element;
    element = element.parentNode;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
  // NOTE: Firefox 34 does not expose ShadowRoot.host (but 37 does)
  if (container.nodeType === container.DOCUMENT_FRAGMENT_NODE && container.host) {
    // the root is attached to a fragment node that has a host
    return container.host;
  }

  return null;
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/shadowed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  var element = (0, _contextToElement2.default)({
    label: 'is/shadowed',
    resolveDocument: true,
    context: context
  });

  return Boolean((0, _shadowHost2.default)({ context: element }));
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _shadowHost = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/observe/interaction-type.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decorateService = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// counters to track primary input
var _activePointers = 0;
/*
  Observe keyboard-, pointer-, mouse- and touch-events so that a query for
  the current interaction type can be made at any time. For pointer interaction
  this observer is limited to pointer button down/up - move is not observed!

  USAGE:
    var listener = engage();
    listener.get() === {pointer: Boolean, key: Boolean}
*/

var _activeKeys = 0;

var pointerStartEvents = ['touchstart', 'pointerdown', 'MSPointerDown', 'mousedown'];
var pointerEndEvents = ['touchend', 'touchcancel', 'pointerup', 'MSPointerUp', 'pointercancel', 'MSPointerCancel', 'mouseup'];

function handleWindowBlurEvent() {
  // reset internal counters when window loses focus
  _activePointers = 0;
  _activeKeys = 0;
}

function handlePointerStartEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  }

  // mousedown without following mouseup
  // (likely not possible in Chrome)
  _activePointers++;
}

function handlePointerEndEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  } else if (event.touches) {
    _activePointers = event.touches.length;
    return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // mouseup without prior mousedown
    // (drag something out of the window)
    _activePointers = Math.max(_activePointers - 1, 0);
  });
}

function handleKeyStartEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // keydown without a following keyup
  // (may happen on CMD+TAB)
  _activeKeys++;
}

function handleKeyEndEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // keyup without prior keydown
    // (may happen on CMD+R)
    _activeKeys = Math.max(_activeKeys - 1, 0);
  });
}

function getInteractionType() {
  return {
    pointer: Boolean(_activePointers),
    key: Boolean(_activeKeys)
  };
}

function disengage() {
  _activePointers = _activeKeys = 0;
  window.removeEventListener('blur', handleWindowBlurEvent, false);
  document.documentElement.removeEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.removeEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerEndEvent, true);
  });
}

function engage() {
  // window blur must be in bubble phase so it won't capture regular blurs
  window.addEventListener('blur', handleWindowBlurEvent, false);
  // handlers to identify the method of focus change
  document.documentElement.addEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.addEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerEndEvent, true);
  });

  return {
    get: getInteractionType
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/style/focus-source.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleClass = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-class.js");

var _shadowFocus = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/event/shadow-focus.js");

var _shadowFocus2 = _interopRequireDefault(_shadowFocus);

var _interactionType = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/observe/interaction-type.js");

var _interactionType2 = _interopRequireDefault(_interactionType);

var _decorateService = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// preferring focusin/out because they are synchronous in IE10+11

/*
  add data-focus-source attribute to html element containing "key", "pointer" or "script"
  depending on the input method used to change focus.

  USAGE:
    style/focus-source()

    body :focus {
      outline: 1px solid grey;
    }

    html[data-focus-source="key"] body :focus {
      outline: 5px solid red;
    }

    html[data-focus-source="key"] body :focus {
      outline: 1px solid blue;
    }

  NOTE: I don't have a GamePad to test, if you do and you want to
  implement an observer for https://w3c.github.io/gamepad/ - send a PR!

  Alternate implementation: https://github.com/alice/modality
*/

var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';

// interface to read interaction-type-listener state
var interactionTypeHandler = void 0;
var shadowHandle = void 0;
// keep track of last focus source
var current = null;
// overwrite focus source for use with the every upcoming focus event
var lock = null;
// keep track of ever having used a particular input method to change focus
var used = {
  pointer: false,
  key: false,
  script: false,
  initial: false
};

function handleFocusEvent(event) {
  var source = '';
  if (event.type === focusEventName || event.type === 'shadow-focus') {
    var interactionType = interactionTypeHandler.get();
    source = lock || interactionType.pointer && 'pointer' || interactionType.key && 'key' || 'script';
  } else if (event.type === 'initial') {
    source = 'initial';
  }

  document.documentElement.setAttribute('data-focus-source', source);

  if (event.type !== blurEventName) {
    if (!used[source]) {
      (0, _toggleClass.addClass)(document.documentElement, 'focus-source-' + source);
    }

    used[source] = true;
    current = source;
  }
}

function getCurrentFocusSource() {
  return current;
}

function getUsedFocusSource(source) {
  return used[source];
}

function lockFocusSource(source) {
  lock = source;
}

function unlockFocusSource() {
  lock = false;
}

function disengage() {
  // clear dom state
  handleFocusEvent({ type: blurEventName });
  current = lock = null;
  Object.keys(used).forEach(function (key) {
    (0, _toggleClass.removeClass)(document.documentElement, 'focus-source-' + key);
    used[key] = false;
  });
  // kill interaction type identification listener
  interactionTypeHandler.disengage();
  // kill shadow-focus event dispatcher
  shadowHandle && shadowHandle.disengage();
  document.removeEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.removeEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.removeEventListener(blurEventName, handleFocusEvent, true);
  document.documentElement.removeAttribute('data-focus-source');
}

function engage() {
  // enable the shadow-focus event dispatcher
  shadowHandle = (0, _shadowFocus2.default)();
  // handlers to modify the focused element
  document.addEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.addEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.addEventListener(blurEventName, handleFocusEvent, true);
  // enable the interaction type identification observer
  interactionTypeHandler = (0, _interactionType2.default)();
  // set up initial dom state
  handleFocusEvent({ type: 'initial' });

  return {
    used: getUsedFocusSource,
    current: getCurrentFocusSource,
    lock: lockFocusSource,
    unlock: unlockFocusSource
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var context = _ref.context,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? 'context-to-element' : _ref$label,
      resolveDocument = _ref.resolveDocument,
      defaultToDocument = _ref.defaultToDocument;

  var element = (0, _nodeArray2.default)(context)[0];

  if (resolveDocument && element && element.nodeType === Node.DOCUMENT_NODE) {
    element = element.documentElement;
  }

  if (!element && defaultToDocument) {
    return document.documentElement;
  }

  if (!element) {
    throw new TypeError(label + ' requires valid options.context');
  }

  if (element.nodeType !== Node.ELEMENT_NODE && element.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
    throw new TypeError(label + ' requires options.context to be an Element');
  }

  return element;
};

var _nodeArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      engage = _ref2.engage,
      disengage = _ref2.disengage;

  var data = {
    engage: engage || noop,
    disengage: disengage || noop,
    instances: 0,
    _result: null
  };

  return initialize.bind(data);
};

/*
  The Singleton Decorator is intended to allow modules to initialize a ("singleton") component as if
  it was the only one using it. Every module gets to initialize and destruct the component by itself.
  Via simple reference counting the component keeps track of how many modules have initialized it,
  so it destructs only when the last module is gone. This decorator hides the component's singleton
  nature from the application in order to offer a homogenous API.

  engage() can return an object (result) with methods to expose to the consumer,
  upon initialization result.disengage is added and returned to the consumer.
*/

function destruct() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      force = _ref.force;

  if (force) {
    this.instances = 0;
  } else {
    this.instances--;
  }

  if (!this.instances) {
    this.disengage();
    this._result = null;
  }
}

function initialize() {
  if (this.instances) {
    this.instances++;
    return this._result;
  }

  this.instances++;
  this._result = this.engage() || {};
  this._result.disengage = destruct.bind(this);

  return this._result;
}

function noop() {}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (input) {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input;
  }

  // instanceof Node - does not work with iframes
  if (input.nodeType !== undefined) {
    return [input];
  }

  if (typeof input === 'string') {
    input = document.querySelectorAll(input);
  }

  if (input.length !== undefined) {
    return [].slice.call(input, 0);
  }

  throw new TypeError('unexpected input ' + String(input));
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleClass = toggleClass;
exports.removeClass = removeClass;
exports.addClass = addClass;
//
// This util allows to easily add, remove or toggle classes.
//
// Using it is neccessary as IE 9 doesn't support element classList
// and IE 11 doesn't support classList for SVG elements
// see also https://developer.mozilla.org/en/docs/Web/API/Element/classList
//
// This file is a replacement for domtokenlist because of
// https://github.com/medialize/ally.js/issues/147
//
// Usage:
//
// toggleClass(div, 'demo'); // Toggles the class `demo`
// toggleClass(div, 'demo', true); // Adds the class `demo`
// toggleClass(div, 'demo', false); // removes the class `demo`
//
// removeClass(div, 'demo');
// addClass(div, 'demo');
//

/**
 * Extract an array of all classNames of the given DOM or SVG node
 */
function getClassNames(element) {
  var className = element.getAttribute && element.getAttribute('class') || '';
  return className === '' ? [] : className.split(' ');
}

function toggleClass(element, className, force) {
  var classNames = getClassNames(element);
  var idx = classNames.indexOf(className);
  var hasClass = idx !== -1;
  var shouldHaveClass = force !== undefined ? force : !hasClass;
  // Break if classes are already set/removed
  if (shouldHaveClass === hasClass) {
    return;
  }
  // Remove class
  if (!shouldHaveClass) {
    classNames.splice(idx, 1);
  }
  // Add class
  if (shouldHaveClass) {
    classNames.push(className);
  }
  element.setAttribute('class', classNames.join(' '));
}

function removeClass(element, className) {
  return toggleClass(element, className, false);
}

function addClass(element, className) {
  return toggleClass(element, className, true);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy() {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/fn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                              jQuery plugin
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              import debug from 'debug';
                                                                                                                                                                                                                                                                              import plugin from '@core/plugins/lib';
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              const ELEMENT_SELECTOR = '[data-my-plugin]';
                                                                                                                                                                                                                                                                              const PLUGIN_NAME = 'MyPlugin';
                                                                                                                                                                                                                                                                              const MODULE_NAME = 'plugins/my-plugin';
                                                                                                                                                                                                                                                                              const log = debug(MODULE_NAME);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              class PluginKlass {
                                                                                                                                                                                                                                                                                  constructor(element, options) {
                                                                                                                                                                                                                                                                                    log('new instance', element, options);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.element = element;
                                                                                                                                                                                                                                                                                    this.options = options;
                                                                                                                                                                                                                                                                                    this.$element = $(element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    log('ready', this.$element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.init();
                                                                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              PluginKlass.DEFAULTS = {
                                                                                                                                                                                                                                                                                someCamelCasedProperty: `${PLUGIN_NAME}:something`,
                                                                                                                                                                                                                                                                              };
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              plugin(PLUGIN_NAME, PluginKlass);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              $(document).ready(() => {
                                                                                                                                                                                                                                                                                $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
                                                                                                                                                                                                                                                                              });
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Then using it in html:
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              <div class="something-else"
                                                                                                                                                                                                                                                                                   data-my-plugin
                                                                                                                                                                                                                                                                                   data-my-plugin--some-camel-cased-property="a-string:something-else"></div>
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Styelguide Core.Global.Javascript.JqueryPlugin
                                                                                                                                                                                                                                                                              */

// import * as events from './events';

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _fn = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/fn.js");

var fn = _interopRequireWildcard(_fn);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js");

var strings = _interopRequireWildcard(_strings);

var _objects = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/objects.js");

var objects = _interopRequireWildcard(_objects);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

var selectors = _interopRequireWildcard(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib');

function plugin(pluginName, klass) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var formattedPluginName = (0, _strings.toCamelCase)(pluginName);
  var dataName = '__' + formattedPluginName;
  var old = _jquery2.default.fn[formattedPluginName];
  var ZERO = 0;

  klass.$bus = {
    subscribe: function subscribe(event, fn) {
      (0, _jquery2.default)(this).bind(event, fn);
    },
    publish: function publish(event, data) {
      (0, _jquery2.default)(this).trigger(event, [data]);
    }
  };

  klass.$util = {
    fn: fn,
    objects: objects,
    strings: strings,
    selectors: selectors
  };

  klass.prototype.selectors = selectors;
  klass.prototype.strings = strings;
  klass.prototype.objects = objects;
  klass.prototype.fn = fn;
  klass.prototype.inViewport = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  _jquery2.default.fn[pluginName] = function PluginFactory(option) {
    return this.each(function PluginInstanceFactory() {
      var $this = (0, _jquery2.default)(this);
      var data = $this.data();
      var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
      var elementOptions = Object.keys(data).filter(function (key) {
        return (0, _strings.toCamelCase)(key).indexOf(formattedPluginName) >= ZERO;
      }).reduce(function (result, path) {
        var data = path && $this.data(path);
        var key = (0, _strings.toCamelCase)(path.replace(new RegExp(formattedPluginName + '-?'), ''));
        log(path, key, $this.data(path));

        if (key && data !== undefined) {
          result[key] = data;
        }
        return result;
      }, {});
      log(pluginName, { elementOptions: elementOptions });
      var instance = $this.data(dataName);
      var options = _jquery2.default.extend({}, klass.DEFAULTS, elementOptions, overrides);

      // store reference to instance
      if (!instance) {
        instance = new klass(this, options);
        instance.$utils = klass.$util;
        $this.data(dataName, instance);
        $this.addClass('u-' + pluginName);
      }

      // execute instance method
      if (typeof option === 'string') {
        instance[option]();
      }
    });
  };

  // - Short hand
  if (shortHand) {
    _jquery2.default[formattedPluginName] = function (options) {
      return (0, _jquery2.default)({})[formattedPluginName](options);
    };
  }

  // - No conflict
  // $.fn[formattedPluginName].noConflict = function noConflict () {
  //   $.fn[formattedPluginName] = old;
  // };
}

function jquery(name) {
  return function decorate(target) {
    plugin(name, target);
  };
}

function defaults(options) {
  return function decorate(target) {
    target.DEFAULTS = options;
  };
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementAttrtibutesToObject = elementAttrtibutesToObject;
exports.objectPath = objectPath;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/objects';
var log = (0, _debug2.default)(MODULE_NAME);

var ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
function elementAttrtibutesToObject(element) {
  var filterFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
    return (0, _strings.toCamelCase)(name);
  };

  var output = {};
  var attrs = Array.from($(element).get(ZERO).attributes);

  if (!attrs) {
    return output;
  }

  log('converting element attributes to object', attrs);

  return attrs.reduce(function (result, attribute) {
    if (filterFn(attribute)) {
      var name = transformFn(attribute.name);
      var value = attribute.value;

      if (value === 'false' || value === 'true') {
        value = Boolean(value);
      }
      result[name] = attribute.value;
    }

    return result;
  }, output);
}

/**
 * Object.prop()
 *
 * Allows dot-notation access to object properties for both getting and setting.
 *
 * @param {Object} obj    The object we're getting from or setting
 * @param {string} prop   The dot-notated string defining the property location
 * @param {mixed}  val    For setting only; the value to set
 */

function objectPath(obj, path, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { delimiter: '.' };

  var props = path.split(options.delimiter);
  var final = props.pop();
  var part = void 0;

  for (var index = 0; index < props.length; index++) {
    part = props[index];
    if (typeof obj[part] === 'undefined') {
      // If we're setting
      if (typeof val !== 'undefined' && index != props.length) {
        // If we're not at the end of the props, keep adding new empty objects
        obj[part] = {};
      } else {
        return undefined;
      }
    }
    obj = obj[part];
  }
  return typeof val !== "undefined" ? obj[final] = val : obj[final];
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.onAvailable = exports.SELECTOR_PATTERNS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.selectorPattern = selectorPattern;
exports.selectTarget = selectTarget;
exports.onChange = onChange;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('core/plugins/lib/selectors');

function selectorPattern() {
	for (var _len = arguments.length, directives = Array(_len), _key = 0; _key < _len; _key++) {
		directives[_key] = arguments[_key];
	}

	return new RegExp('\\((' + directives.join('|') + ')(.*)\\)\\s?(.*)');
}

var SELECTOR_PATTERNS = exports.SELECTOR_PATTERNS = {

	// .find
	"children": selectorPattern('children'),

	// .closest
	"parent": selectorPattern('parent'),
	"from": selectorPattern('from'),
	"parents": selectorPattern('parents'),
	"siblings": selectorPattern('siblings'),
	"here": selectorPattern('here'),
	"self": selectorPattern('self')
};

function selectTarget(selector, $element) {
	var $target = void 0;

	var isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
	var isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
	var isRetargeted = selector.match(SELECTOR_PATTERNS.from);
	var isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
	var isGenerational = selector.match(SELECTOR_PATTERNS.here);
	var isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
	var isSelfish = selector.match(SELECTOR_PATTERNS.self);

	// special retargeting root
	if (isRetargeted) {
		log('isRetargeted', isRetargeted[2], isRetargeted[3]);
		var $newElement = selectTarget(isRetargeted[2], $element);
		var newSelector = '(children) ' + isRetargeted[3];
		log('isRetargeted.newElement', $newElement);
		log('isRetargeted.newSelector', newSelector);
		$target = selectTarget(newSelector, $newElement);
		log('isRetargeted.target', $target);
	}

	// target is all ancestors
	else if (isAllAncestoral) {
			log('isAllAncestoral', isAllAncestoral);
			$target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
		}
		// target is closest ancestor
		else if (isClosestAncestoral) {
				log('isClosestAncestoral', isClosestAncestoral);
				$target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
			}
			// target is somewhere under current parent
			else if (isGenerational) {
					log('isGenerational', isGenerational);
					$target = $element.parent().find(isGenerational[isGenerational.length - 1]);
				}
				// target is only under self
				else if (isAllDescendants) {
						log('isAllDescendants', isAllDescendants);
						$target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
					}
					// target is somewhere in siblings only
					else if (isSiblings) {
							log('isSiblings', isSiblings);
							$target = $element.siblings(isSiblings[isSiblings.length - 1]);
						}
						// target is source
						else if (!selector || isSelfish) {
								log('isSelfish', isSelfish);
								var selector = isSelfish[isSelfish.length - 1] || '*';
								$target = $element.filter(selector);
							}
							// target could be anywhere
							else {
									log('global', selector);
									$target = (0, _jquery2.default)(selector);
								}
	return $target;
}

var OnAvailable = function () {
	function OnAvailable(root) {
		_classCallCheck(this, OnAvailable);

		this.root = root || window.document.documentElement;
		this.listeners = [];
		this.observer;
	}

	_createClass(OnAvailable, [{
		key: 'ready',
		value: function ready(selector, fn) {
			// Store the selector and callback to be monitored
			this.listeners.push({
				selector: selector,
				fn: fn
			});

			if (!this.observer) {
				// Watch for changes in the document
				this.observer = onChange(this.root, this.check.bind(this), {
					childList: true,
					subtree: true
				});
			}
			// Check if the element is currently in the DOM
			this.check();
		}
	}, {
		key: 'check',
		value: function check() {
			var _this = this;

			var listnersSelectorsArray = [];
			Array.from(this.listeners).forEach(function (listener) {
				listnersSelectorsArray.push(listener.selector);
			});
			var listnersSelectors = listnersSelectorsArray.join(",");
			var matchingElements = this.root.querySelectorAll(listnersSelectors);
			// Check the DOM for elements matching a stored selector

			Array.from(matchingElements).forEach(function (element) {

				Array.from(_this.listeners).forEach(function (listener) {
					var attributeName = listener.selector.substring(1, listener.selector.length - 1);
					if (element.hasAttribute(attributeName) && !element[attributeName]) {
						// console.log(element, attributeName);
						listener.fn.call(element, element);
						element[attributeName] = true;
					}
				});
			});

			// for (
			// 	var i = 0, len = this.listeners.length, listener, elements;
			// 	i < len;
			// 	i++
			// ) {
			// 	listener = this.listeners[i];
			// 	debugger;
			// 	// Query for elements matching the specified selector
			// 	elements = this.root.querySelectorAll(listener.selector);
			// 	for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
			// 		element = elements[j];
			// 		// Make sure the callback isn't invoked with the
			// 		// same element more than once
			// 		if (!element.ready) {
			// 			element.ready = true;
			// 			// Invoke the callback with the element
			// 			listener.fn.call(element, element);
			// 		}
			// 	}
			// }
		}
	}]);

	return OnAvailable;
}();

var onAvailable = exports.onAvailable = new OnAvailable(window.document.documentElement);

function onChange(element, fn, options) {
	var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	var observer = new MutationObserver(fn);
	observer.observe(element, options || {
		attributes: true,
		childList: true,
		subtree: true
	});
	return observer;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;
exports.booleanify = booleanify;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/jquery_plugin/strings');

function preserveCamelCase(str) {
  var isLastCharLower = false;
  var isLastCharUpper = false;
  var isLastLastCharUpper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = str.substr(0, i) + '-' + str.substr(i);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = str.substr(0, i - 1) + '-' + str.substr(i - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }

  return str;
}

function toCamelCase(str) {
  if (arguments.length > 1) {
    str = Array.from(arguments).map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x.length;
    }).join('-');
  } else {
    str = str.trim();
  }

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }

  var hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
    return p1.toUpperCase();
  });
};

function tmpl(str, context) {
  var result = str;

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });
  }

  return result;
}

function $tmpl(element, context) {
  var $target = (0, _jquery2.default)(element);
  var templateString = $target.attr('data-text-template');
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  log('mustache', { template: template, self: self, parent: parent, invert: invert });

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {

      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }

      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
      log('mustache.output.' + depth, { output: output });
    });
  }
  log('mustache.output', { output: output });
  return output;
}

function booleanify(value) {
  var lower = value.toLowerCase();
  if (lower === 'false' || lower === '0') {
    return false;
  }
  return new Boolean(value);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/disqus/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-disqus]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'disqus';

var log = (0, _debug2.default)('components/disqus');

var Disqus = function () {
	function Disqus(element, options) {
		_classCallCheck(this, Disqus);

		this.options = options;

		this.init();
	}

	_createClass(Disqus, [{
		key: 'init',
		value: function init() {
			log('init', this.options);

			var config = this.options.pageConfig;

			window.disqus_config = function () {
				for (var prop in config) {
					this.page[prop] = config[prop];
				}
			};

			var dsq = document.createElement('script');
			dsq.type = 'text/javascript';
			dsq.async = true;
			dsq.src = '//' + this.options.shortname + '.disqus.com/embed.js';
			dsq.setAttribute('data-timestamp', +new Date());
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);
		}
	}]);

	return Disqus;
}();

Disqus.DEFAULTS = {};

//plugin(PLUGIN_NAME, Disqus);

// $(document).ready(() => {
// 	$(ELEMENT_SELECTOR).each(function() {
// 		const element = this;
// 		$(element)[PLUGIN_NAME]();
// 	});
// });

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		(0, _lib2.default)(PLUGIN_NAME, Disqus);
		(0, _jquery2.default)(element)[PLUGIN_NAME]();
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/gallery/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-image-gallery]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'imageGallery';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("component--gallery").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/gallery/component.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/profile-banner/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/gallery/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/disqus/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/people-featured-layout/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/people-featured-layout/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-profile-carousel]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'profileCarousel';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("component--profile-carousel").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/people-featured-layout/profile-carousel.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var files = __webpack_require__("/tool/project/client/src/site__ale001/components/blocks/profile-banner/images nonrecursive /\\.png$/");
files.keys().forEach(files);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/profile-banner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site-header/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/wysiwyg/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/truncate-tel/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/blocks/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/contents-menu/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-contents-menu]';
var PLUGIN_NAME = 'ContentsMenu';

$(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--contents-menu").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/contents-menu/contents-menu.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/document-title/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-document-title]';
var PLUGIN_NAME = 'DocumentTitle';

$(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--document-title").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/document-title/document-title.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/contents-menu/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/long-content/document-title/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/global-search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/global-search/search-form-collapsible.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/global-search/search-form-collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-search-form-collapsible]';
var PLUGIN_NAME = 'searchFormCollapsible';

var log = (0, _debug2.default)('site-header/header-controller:search');

var SearchFormCollapsible = function () {
	function SearchFormCollapsible(element, options) {
		_classCallCheck(this, SearchFormCollapsible);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.enabled = false;

		this.formElements = this.selectors.selectTarget(this.options.elementsSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(SearchFormCollapsible, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.$element.on('togglesearch', this.toggle.bind(this));
			this.$element.on('disablesearch', this.disable.bind(this));
		}
	}, {
		key: 'enable',
		value: function enable() {
			this.formElements.removeAttr('disabled');
			this.enabled = true;
			this.formElements[0].focus();
			log('enable');
		}
	}, {
		key: 'disable',
		value: function disable() {
			this.formElements.attr('disabled', 'disabled');
			this.enabled = false;
			log('disable');
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			var handler = this.enabled ? this.disable.bind(this) : this.enable.bind(this);
			log('toggle');
			handler();

			if (this.enabled) {
				// Bubble to components listening to site-header events
				this.element.dispatchEvent(new CustomEvent("search_revealed", {
					bubbles: true,
					cancelable: true
					// detail: {}
				}));
			}
		}
	}]);

	return SearchFormCollapsible;
}();

SearchFormCollapsible.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, SearchFormCollapsible);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/search-dropdown/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/global-search/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/search-results-filter-panel.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/search-filter-date.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/search-filter-date-range.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/search-filter-date-range.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-search-filter-date-range]';
var PLUGIN_NAME = 'searchFilterDateRange';

var log = (0, _debug2.default)('search/results-filter/search-filter-date:range');

var SearchFilterDateRange = function () {
	function SearchFilterDateRange(element, options) {
		_classCallCheck(this, SearchFilterDateRange);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.form = this.selectors.selectTarget('(parents) form', this.$element);

		this.allCheckbox = this.selectors.selectTarget(this.options.allCheckboxSelector, this.$element);

		this.dateComponents = this.selectors.selectTarget(this.options.dateComponentsSelector, this.$element);

		this.fromInput = this.selectors.selectTarget(this.options.fromInputSelector, this.$element);

		this.toInput = this.selectors.selectTarget(this.options.toInputSelector, this.$element);

		this.validationMessage = this.selectors.selectTarget(this.options.validationMessageSelector, this.$element);

		this.watch();

		log('ready', this);
	}

	_createClass(SearchFilterDateRange, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.allCheckbox.on('change', this.onCheckboxChange.bind(this));

			this.form.on('submit', this.onSubmit.bind(this));

			//	'date-changed' event bubbled from child components
			this.$element.on('datechange', this.onDateChanged.bind(this));
		}
	}, {
		key: 'isUnfiltered',
		value: function isUnfiltered(from, to) {
			return !from && !to;
		}
	}, {
		key: 'isFullDate',
		value: function isFullDate(date) {
			return date.length === 6;
		}
	}, {
		key: 'hasDateRange',
		value: function hasDateRange(fromDate, toDate) {
			return this.isFullDate(fromDate) && this.isFullDate(toDate);
		}
	}, {
		key: 'isValidDateRange',
		value: function isValidDateRange(from, to) {
			return from <= to;
		}
	}, {
		key: 'onCheckboxChange',
		value: function onCheckboxChange() {
			if (this.allCheckbox.is(':checked')) {
				this.dateComponents.searchFilterDate('reset');
			}
		}
	}, {
		key: 'shouldDisplayRangeError',
		value: function shouldDisplayRangeError(fromValue, toValue) {

			if (!this.hasDateRange(fromValue, toValue)) {
				return false;
			}

			return !this.isValidDateRange(fromValue, toValue);
		}
	}, {
		key: 'updateValidation',
		value: function updateValidation(fromValue, toValue) {
			if (this.shouldDisplayRangeError(fromValue, toValue)) {
				this.validationMessage.removeAttr('hidden');
			} else {
				this.validationMessage.attr('hidden', 'hidden');
			}
		}
	}, {
		key: 'onDateChanged',
		value: function onDateChanged() {
			var from = this.fromInput[0].value;
			var to = this.toInput[0].value;
			this.allCheckbox.prop('checked', this.isUnfiltered(from, to));
			this.updateValidation(from, to);
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit(event) {
			var from = this.fromInput[0].value;
			var to = this.toInput[0].value;
			var isInvalid = this.shouldDisplayRangeError(from, to);

			this.updateValidation(from, to);

			if (isInvalid) {
				event.preventDefault();
			}
		}
	}]);

	return SearchFilterDateRange;
}();

SearchFilterDateRange.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, SearchFilterDateRange);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/search-filter-date.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-search-filter-date]';
var PLUGIN_NAME = 'searchFilterDate';

var log = (0, _debug2.default)('search/results-filter/search-filter-date:date');

var SearchFilterDate = function () {
	function SearchFilterDate(element, options) {
		_classCallCheck(this, SearchFilterDate);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.form = this.selectors.selectTarget('(parents) form', this.$element);

		this.monthSelect = this.selectors.selectTarget(this.options.monthSelectSelector, this.$element);

		this.yearSelect = this.selectors.selectTarget(this.options.yearSelectSelector, this.$element);

		this.valueInput = this.selectors.selectTarget(this.options.valueInputSelector, this.$element);

		this.validationMessage = this.selectors.selectTarget(this.options.validationMessageSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(SearchFilterDate, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.form.on('submit', this.onSubmit.bind(this));

			this.monthSelect.on('change', this.onChange.bind(this));
			this.yearSelect.on('change', this.onChange.bind(this));
		}
	}, {
		key: 'hasValue',
		value: function hasValue(month, year) {
			var hasMonth = month !== '0';
			var hasYear = year !== '0';

			return hasMonth || hasYear;
		}
	}, {
		key: 'isValid',
		value: function isValid(month, year) {
			var hasMonth = month !== '0';
			var hasYear = year !== '0';

			return hasMonth && hasYear || !hasMonth && !hasYear;
		}
	}, {
		key: 'updateValidation',
		value: function updateValidation(month, year) {
			var shouldDisplay = !this.isValid(month, year);
			if (shouldDisplay) {
				this.validationMessage.removeAttr('hidden');
			} else {
				this.validationMessage.attr('hidden', 'hidden');
			}
		}
	}, {
		key: 'updateValue',
		value: function updateValue(month, year) {
			var newValue = this.hasValue(month, year) ? '' + year + month : '';
			this.valueInput.val(newValue);
		}

		// trigger this method from parent date range

	}, {
		key: 'reset',
		value: function reset() {
			this.monthSelect.val('0');
			this.yearSelect.val('0');
			this.updateValue('0', '0');
			this.updateValidation('0', '0');
		}
	}, {
		key: 'onChange',
		value: function onChange() {
			var monthValue = this.monthSelect.val();
			var yearValue = this.yearSelect.val();
			var isValid = this.isValid(monthValue, yearValue);

			// Don't show validation errors before submiting
			if (isValid) {
				this.updateValidation(monthValue, yearValue);
			}

			// update here to update All dates checkbox immediately
			this.updateValue(monthValue, yearValue);

			this.$element.trigger('datechange');
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit(event) {
			log('submit');
			var monthValue = this.monthSelect.val();
			var yearValue = this.yearSelect.val();
			var isValid = this.isValid(monthValue, yearValue);

			// these may be redundant as they will have been called onChange?
			this.updateValidation(monthValue, yearValue);
			this.updateValue(monthValue, yearValue);

			if (!isValid) {
				event.preventDefault();
			}
		}
	}]);

	return SearchFilterDate;
}();

SearchFilterDate.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, SearchFilterDate);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/results-filter/search-results-filter-panel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('components/search/search-result-filter-panel');
var select = {
	ALL_CHECKBOX: '[data-search-filter-panel__choice-all]',
	CHOICE_CHECKBOX: '[data-search-filter-panel__choice]',
	FILTER_GROUP: '[data-search-filter-panel__group]',
	VALUE_INPUT: '[data-search-filter-panel__group-values]'
};

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(select.ALL_CHECKBOX).on('change', function () {
		if (!this || !this.checked) {
			return;
		}
		var allCheckbox = (0, _jquery2.default)(this);
		var thisGroup = allCheckbox.parents(select.FILTER_GROUP);
		var allOptions = thisGroup.find(select.CHOICE_CHECKBOX);
		var valueInput = thisGroup.find(select.VALUE_INPUT);

		allOptions.each(function (index, choice) {
			choice.checked = false;
		});

		valueInput.val('');
	});

	(0, _jquery2.default)(select.CHOICE_CHECKBOX).on('change', function () {
		var thisOption = (0, _jquery2.default)(this);
		var thisGroup = thisOption.parents(select.FILTER_GROUP);
		var allCheckbox = thisGroup.find(select.ALL_CHECKBOX);
		var allOptions = thisGroup.find(select.CHOICE_CHECKBOX);
		var valueInput = thisGroup.find(select.VALUE_INPUT);

		var collatedValue = allOptions.filter(':checked').map(function (index, input) {
			return input.value;
		}).get().join();

		allCheckbox.prop('checked', false);
		valueInput.val(collatedValue);
	});

	log('mounted');
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/search-dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-search-dropdown]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'SearchDropdown';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--search-dropdown").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/search/search-dropdown/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site-header/header/header-controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-header-controller]";
var PLUGIN_NAME = "headerController";

var log = (0, _debug2.default)("site-header/header-controller:header");

var HeaderController = function () {
	function HeaderController(element, options) {
		_classCallCheck(this, HeaderController);

		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.isSearchCollapsible = !!this.options.searchComponentSelector;

		this.searchComponent = this.isSearchCollapsible && this.selectors.selectTarget(this.options.searchComponentSelector, this.$element);

		this.watch();

		log("ready", this, this.$target);
	}

	_createClass(HeaderController, [{
		key: "watch",
		value: function watch() {
			var _this = this;

			log("watching");

			var self = this;

			this.element.addEventListener("navigation_toggled", this.handleNavigationToggle.bind(this));

			this.element.addEventListener("contents_menu_opened", this.handleContentsOpened.bind(this));

			this.$element.find("[data-collapsible]").on("collapsible_opened", self.handleContentsOpened.bind(self));

			document.addEventListener("click", function (event) {

				var collapsibleElement = _this.$element.find("[data-collapsible]")[0];
				if (!collapsibleElement) {
					return false;
				}

				var isClickedOutside = !collapsibleElement.contains(event.target);

				if (isClickedOutside) {
					// Hide the target element
					collapsibleElement.setAttribute('data-collapsible-open', 'false');
				}
			});
		}
	}, {
		key: "handleNavigationToggle",
		value: function handleNavigationToggle() {
			this.tryConcealSearch();
			this.tryConcealCollapsible();
		}
	}, {
		key: "tryConcealSearch",
		value: function tryConcealSearch() {
			log("attempting to disable search");
			if (this.isSearchCollapsible) {
				this.searchComponent.trigger("disablesearch");
				this.element.classList.remove("site-header--global-search-is-open");
			} else {
				log("Search is not collapsible");
			}
		}
	}, {
		key: "tryConcealCollapsible",
		value: function tryConcealCollapsible() {
			Array.from(this.element.querySelectorAll("[data-collapsible]")).forEach(function (item) {
				item.setAttribute('data-collapsible-open', 'false');
			});
		}
	}, {
		key: "closeMegaMenus",
		value: function closeMegaMenus() {
			var _this2 = this;

			Array.from(document.querySelectorAll("." + this.options.navigationActiveClass)).forEach(function (activeItem) {
				activeItem.classList.remove(_this2.options.navigationActiveClass);
			});
		}
	}, {
		key: "handleContentsOpened",
		value: function handleContentsOpened() {
			this.tryConcealSearch();
			this.closeMegaMenus();
		}
	}]);

	return HeaderController;
}();

HeaderController.DEFAULTS = {
	navigationActiveClass: "navigation__item--is-active"
};

(0, _lib2.default)(PLUGIN_NAME, HeaderController);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site-header/header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site-header/header/header-controller.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site-header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site-header/header/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site/sprites/index.js");

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './icons/icons__config'; // icon font import
var log = (0, _debug2.default)('site__ale001');

$(function () {
	log('ready');
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/site/sprites/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
SVG Sprite

Markup:
<svg class="{{ classes }}"
  role="img"
  aria-labelledby="title"
  focusable="false">
  <use
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xlink:href="{{ asseturl '/static/theme/images/sprites.svg' }}#{{ default sprite modifier_class }}"></use>
</svg>

Weight: 30

Styleguide ale001.Components.SvgSprite
*/
var files = __webpack_require__("/tool/project/client/src/site__ale001/components/site/sprites nonrecursive /\\.svg$/");
files.keys().forEach(files);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/truncate-tel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-truncate-tel]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'truncateTel';

var log = (0, _debug2.default)('components/truncateTel');

var TruncateTel = function () {
	function TruncateTel(element, options) {
		_classCallCheck(this, TruncateTel);

		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.init();
	}

	_createClass(TruncateTel, [{
		key: 'init',
		value: function init() {
			log('init', this.$target);
			this.button = this.makeButton();
			this.hideNumber();
			this.watch();
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.button.on('click', this.revealNumber.bind(this));
		}
	}, {
		key: 'getButtonText',
		value: function getButtonText() {
			return this.$element.text().trim().split(' ').slice(0, -1).join(' ') + '…';
		}
	}, {
		key: 'makeButton',
		value: function makeButton() {
			var buttonHtml = (0, _jquery2.default)('<button></button>', {
				class: this.options.buttonClass,
				'aria-label': this.options.buttonLabel,
				type: 'button',
				text: this.getButtonText()
			});

			return buttonHtml;
		}
	}, {
		key: 'hideNumber',
		value: function hideNumber() {
			this.$element.addClass(this.options.hideNumberClass);
			this.button.insertAfter(this.$element);
		}
	}, {
		key: 'revealNumber',
		value: function revealNumber() {
			this.$element.removeClass(this.options.hideNumberClass).focus();
			this.button.detach();
		}
	}]);

	return TruncateTel;
}();

TruncateTel.DEFAULTS = {
	hideNumberClass: 'truncate-tel--hidden'
};

(0, _lib2.default)(PLUGIN_NAME, TruncateTel);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function (index, element) {
		(0, _jquery2.default)(element)[PLUGIN_NAME]();
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/wysiwyg/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/wysiwyg/tables.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/wysiwyg/tables.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

var ELEMENT_SELECTOR = '.table--scrollable'; //$('.table--scrollable').wrapAll('<div class="scrollable"></div>');

$(function () {
    _selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
        $(element).wrapAll('<div class="scrollable"></div>');
    });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/components/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/utilities/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/utilities/a11y__focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _focusSource = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/style/focus-source.js");

var _focusSource2 = _interopRequireDefault(_focusSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _focusSource2.default)();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/utilities/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/utilities/a11y__focus.js");

/***/ }),

/***/ "/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!/tool/node_modules/css-loader/index.js??ref--10-1!/tool/node_modules/postcss-loader/lib/index.js??ref--10-2!/tool/node_modules/sass-loader/lib/loader.js??ref--10-3!/tool/project/client/src/site__ale001/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/tool/node_modules/file-loader/dist/cjs.js??ref--6-0!/tool/node_modules/img-loader/index.js??ref--6-1!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/ourpeople-placeholder.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/ourpeople-placeholder--4dc6abf87d23332128e537ff2713b746.png";

/***/ }),

/***/ "/tool/node_modules/file-loader/dist/cjs.js??ref--6-0!/tool/node_modules/img-loader/index.js??ref--6-1!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/profile-placeholder.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/profile-placeholder--196e41dbab23f6b8e1e05611c00a4fbe.png";

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/about.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "about-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#about-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/alert.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "alert-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#alert-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/allens-linklaters-logo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "allens-linklaters-logo-usage",
      viewBox: "0 0 146 16",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#allens-linklaters-logo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/allens-logo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "allens-logo-usage",
      viewBox: "0 0 145 38",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#allens-logo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/allens-on-air.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "allens-on-air-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#allens-on-air-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/anchor-link-down.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "anchor-link-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#anchor-link-down-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/anchor-link-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "anchor-link-up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#anchor-link-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/arrow-left.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "arrow-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/arrow-right.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "arrow-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/bookmark.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "bookmark-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#bookmark-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chapter-toggle-shape-large.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chapter-toggle-shape-large-usage",
      viewBox: "0 0 180 104",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#chapter-toggle-shape-large-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chapter-toggle-shape-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chapter-toggle-shape-small-usage",
      viewBox: "0 0 60 76",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#chapter-toggle-shape-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/checkbox-checked.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "checkbox-checked-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#checkbox-checked-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-down-square.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-down-square-usage",
      viewBox: "0 0 12 13",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#chevron-down-square-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-down.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-left.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#chevron-left-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-right.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#chevron-right-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#chevron-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/clock.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "clock-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/close-megamenu.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "close-megamenu-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#close-megamenu-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/cog.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "cog-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#cog-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/contact.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "contact-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#contact-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/content-toggle-closed.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "content-toggle-closed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#content-toggle-closed-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/content-toggle-open.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "content-toggle-open-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#content-toggle-open-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/facebook.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/filter.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "filter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#filter-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/globe.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "globe-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#globe-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/grad-site-logo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "grad-site-logo-usage",
      viewBox: "0 0 206.91 46.23",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#grad-site-logo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/home.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "home-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#home-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/insights.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "insights-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#insights-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/link-external.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "link-external-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#link-external-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/linkedin-icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "linkedin-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#linkedin-icon-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/linkedin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/list.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "list-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#list-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/location-pin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "location-pin-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#location-pin-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/logout.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "logout-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#logout-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/mail.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "mail-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/menu-close.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "menu-close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#menu-close-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/menu-open.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "menu-open-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#menu-open-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/minus.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "minus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#minus-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/network.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "network-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#network-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/news.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "news-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#news-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/nucleus.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "nucleus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#nucleus-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/padlock.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "padlock-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#padlock-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/paper-plane.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "paper-plane-usage",
      viewBox: "0 0 234 171",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#paper-plane-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/password.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "password-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#password-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/people.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "people-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#people-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/person-alternative.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "person-alternative-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#person-alternative-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/person.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "person-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#person-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/phone.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/play-large.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "play-large-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#play-large-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/play-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "play-small-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#play-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/plus.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/search-detailed.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-detailed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#search-detailed-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/search-nav.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-nav-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#search-nav-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/search-no-results.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-no-results-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#search-no-results-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/services.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "services-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#services-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/spinner.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "spinner-usage",
      viewBox: "0 0 106 106",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#spinner-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/suitcase.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "suitcase-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#suitcase-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/tick-circle.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "tick-circle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#tick-circle-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/tick.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "tick-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#tick-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/touch.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "touch-usage",
      viewBox: "0 0 290 150",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#touch-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/twitter.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/user-profile-large.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "user-profile-large-usage",
      viewBox: "0 0 96 96",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#user-profile-large-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/user-profile.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "user-profile-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#user-profile-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/user.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "user-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#user-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/youtube.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#youtube-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/tool/project/client/src/site__ale001/components/blocks/profile-banner/images nonrecursive /\\.png$/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ourpeople-placeholder.png": "/tool/node_modules/file-loader/dist/cjs.js??ref--6-0!/tool/node_modules/img-loader/index.js??ref--6-1!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/ourpeople-placeholder.png",
	"./profile-placeholder.png": "/tool/node_modules/file-loader/dist/cjs.js??ref--6-0!/tool/node_modules/img-loader/index.js??ref--6-1!/tool/project/client/src/site__ale001/components/blocks/profile-banner/images/profile-placeholder.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tool/project/client/src/site__ale001/components/blocks/profile-banner/images nonrecursive /\\.png$/";

/***/ }),

/***/ "/tool/project/client/src/site__ale001/components/site/sprites nonrecursive /\\.svg$/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/about.svg",
	"./alert.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/alert.svg",
	"./allens-linklaters-logo.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/allens-linklaters-logo.svg",
	"./allens-logo.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/allens-logo.svg",
	"./allens-on-air.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/allens-on-air.svg",
	"./anchor-link-down.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/anchor-link-down.svg",
	"./anchor-link-up.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/anchor-link-up.svg",
	"./arrow-left.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/arrow-left.svg",
	"./arrow-right.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/arrow-right.svg",
	"./bookmark.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/bookmark.svg",
	"./chapter-toggle-shape-large.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chapter-toggle-shape-large.svg",
	"./chapter-toggle-shape-small.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chapter-toggle-shape-small.svg",
	"./checkbox-checked.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/checkbox-checked.svg",
	"./chevron-down-square.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-down-square.svg",
	"./chevron-down.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-down.svg",
	"./chevron-left.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-left.svg",
	"./chevron-right.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-right.svg",
	"./chevron-up.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/chevron-up.svg",
	"./clock.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/clock.svg",
	"./close-megamenu.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/close-megamenu.svg",
	"./cog.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/cog.svg",
	"./contact.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/contact.svg",
	"./content-toggle-closed.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/content-toggle-closed.svg",
	"./content-toggle-open.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/content-toggle-open.svg",
	"./facebook.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/facebook.svg",
	"./filter.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/filter.svg",
	"./globe.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/globe.svg",
	"./grad-site-logo.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/grad-site-logo.svg",
	"./home.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/home.svg",
	"./insights.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/insights.svg",
	"./link-external.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/link-external.svg",
	"./linkedin-icon.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/linkedin-icon.svg",
	"./linkedin.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/linkedin.svg",
	"./list.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/list.svg",
	"./location-pin.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/location-pin.svg",
	"./logout.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/logout.svg",
	"./mail.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/mail.svg",
	"./menu-close.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/menu-close.svg",
	"./menu-open.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/menu-open.svg",
	"./minus.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/minus.svg",
	"./network.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/network.svg",
	"./news.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/news.svg",
	"./nucleus.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/nucleus.svg",
	"./padlock.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/padlock.svg",
	"./paper-plane.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/paper-plane.svg",
	"./password.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/password.svg",
	"./people.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/people.svg",
	"./person-alternative.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/person-alternative.svg",
	"./person.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/person.svg",
	"./phone.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/phone.svg",
	"./play-large.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/play-large.svg",
	"./play-small.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/play-small.svg",
	"./plus.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/plus.svg",
	"./search-detailed.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/search-detailed.svg",
	"./search-nav.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/search-nav.svg",
	"./search-no-results.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/search-no-results.svg",
	"./services.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/services.svg",
	"./spinner.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/spinner.svg",
	"./suitcase.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/suitcase.svg",
	"./tick-circle.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/tick-circle.svg",
	"./tick.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/tick.svg",
	"./touch.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/touch.svg",
	"./twitter.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/twitter.svg",
	"./user-profile-large.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/user-profile-large.svg",
	"./user-profile.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/user-profile.svg",
	"./user.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/user.svg",
	"./youtube.svg": "/tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/youtube.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tool/project/client/src/site__ale001/components/site/sprites nonrecursive /\\.svg$/";

/***/ }),

/***/ "external \"jQuery\"":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "multi /tool/project/client/src/site__ale001/index.js /tool/project/client/src/site__ale001/index.scss":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__ale001/index.js");
module.exports = __webpack_require__("/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!/tool/node_modules/css-loader/index.js??ref--10-1!/tool/node_modules/postcss-loader/lib/index.js??ref--10-2!/tool/node_modules/sass-loader/lib/loader.js??ref--10-3!/tool/project/client/src/site__ale001/index.scss");


/***/ })

},["multi /tool/project/client/src/site__ale001/index.js /tool/project/client/src/site__ale001/index.scss"]);


// WEBPACK FOOTER //
// scripts/site__ale001--dddf2e515c3915cd83c1.js